import Head from "next/head";
import * as S from "./Story.styles";

export default function Story() {
  return (
    <>
      <Head>
        <meta
          name="description"
          property="og:description"
          content="The place to learn how David and Chloë met"
        />
        <title>Story • David &amp; Chloë</title>
      </Head>

      <S.Container>
        <p>
          David and Chloë first met in January 2019 at a{" "}
          <a
            href="https://twitter.com/fiftyfivebar "
            target="_blank"
            rel="noopener noreferrer"
          >
            bar in Camden
          </a>
          . David greatly regrets the choice of location for this first date, as
          he now realises it was not at all classy enough for Chloë. Chloë
          arrived 10 minutes early, whilst David was late by arriving on time.
        </p>
        <p>
          Conversation on this first date included playing Jewish geography and
          working out that he knew{" "}
          <a
            href="https://michaelrose.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            her uncle
          </a>
          , as well as numerous friends from the{" "}
          <a
            href="https://www.bbc.co.uk/news/education-37489745"
            target="_blank"
            rel="noopener noreferrer"
          >
            University of Birmingham
          </a>{" "}
          which must have been &apos;Sint&apos;ilating, because Chloë agreed to
          a second date whilst still on the first!
        </p>
        <p>
          Through sheer Mazal (luck) or a higher power, both David and Chloë
          were independently invited to the same{" "}
          <a
            href="https://www.youtube.com/watch?v=dQjXifn1edo"
            target="_blank"
            rel="noopener noreferrer"
          >
            Friday Night Dinner
          </a>{" "}
          the very next day, which if they weren&apos;t already sure, sealed the
          deal.
        </p>
        <p>
          In the two years since, they have grown to love and support each other
          in so many ways. Chloë has helped David whilst he finished his degree
          - including reading over 50 pages of David&apos;s nonsensical{" "}
          <a
            href="static/Can Twitter be a Herald for the Stock Market.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            final year project
          </a>
          . David has kept Chloë calm on more than one occasion when she was
          being overdramatic. Chloë has improved David’s cultural knowledge by
          listening to Magic Radio every day, and taking him to{" "}
          <a
            href="https://www.youtube.com/watch?v=1q82twrdr0U"
            target="_blank"
            rel="noopener noreferrer"
          >
            musicals
          </a>
          , which as it turns out have a live orchestra actually there rather
          than a CD. The young couple were only able to get abroad together four
          months after they were already engaged (to Mallorca, David is yet to
          convince Chloë to come skiing), but they are looking forward to many
          more vacations in the future.
        </p>
        <p>
          After two years of laughs, tears, hardships and joy (and a minor
          global pandemic which separated them for three months), they knew that
          their future years would always be together. For David and Chloë it
          was never a question of ‘if’ but ‘when’. And then, in April 2021,
          amongst the bluebells at the Ashridge Estate, that special question
          was asked and answered.
        </p>
        <p>
          The pair look forward to you joining them as they embark on the next
          chapter of their lives as a married couple.
        </p>
      </S.Container>
    </>
  );
}
